import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function PembayaranKredit() {
  const [tagihan, setTagihan] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [showModal, setShowModal] = useState(false)
  const [selected, setSelected] = useState(null)
  const [form, setForm] = useState({ TglBayar: new Date().toISOString().slice(0, 10), JumlahBayar: '' })

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await serbaUsahaService.getTagihan({ page, limit: 20 })
      setTagihan(res.data.data || [])
      setTotalPages(res.data.meta?.totalPages || 1)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  useEffect(() => { fetchData() }, [page])

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)
  const formatDate = (d) => {
    if (!d) return '-'
    return new Date(d).toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const handleBayar = async (e) => {
    e.preventDefault()
    if (!form.JumlahBayar || form.JumlahBayar <= 0) return alert('Jumlah bayar harus lebih dari 0')
    try {
      await serbaUsahaService.bayarAngsuran(selected.NoTransaksi, form)
      alert('Pembayaran berhasil!')
      setShowModal(false); setSelected(null)
      setForm({ TglBayar: new Date().toISOString().slice(0, 10), JumlahBayar: '' })
      fetchData()
    } catch (err) { alert('Gagal: ' + (err.response?.data?.message || err.message)) }
  }

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Pembayaran Kredit</h3></div>
      <div className="card-body">
        {loading ? <div className="text-center py-3"><i className="fas fa-spinner fa-spin fa-2x"></i></div> : (
          <table className="table table-bordered table-hover">
            <thead><tr>
              <th>No. Transaksi</th><th>Tgl</th><th>Anggota</th><th>Total</th><th>Sisa</th><th>Aksi</th>
            </tr></thead>
            <tbody>
              {tagihan.length === 0 ? <tr><td colSpan="6" className="text-center">Tidak ada tagihan aktif</td></tr> :
                tagihan.map((t, i) => (
                  <tr key={i}>
                    <td>{t.NoTransaksi}</td>
                    <td>{formatDate(t.TglTransaksi)}</td>
                    <td>{t.NamaAnggota || '-'}</td>
                    <td className="text-right">{formatCurrency(t.TotalHarga)}</td>
                    <td className="text-right">{formatCurrency(t.SisaPembayaran)}</td>
                    <td>
                      <button className="btn btn-sm btn-success"
                        onClick={() => { setSelected(t); setForm({ TglBayar: new Date().toISOString().slice(0, 10), JumlahBayar: t.SisaPembayaran }); setShowModal(true) }}>
                        Bayar
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            {Array.from({ length: totalPages }, (_, i) => (
              <button key={i} className={`btn btn-sm ${page === i + 1 ? 'btn-primary' : 'btn-default'} mx-1`} onClick={() => setPage(i + 1)}>{i + 1}</button>
            ))}
          </div>
        )}
      </div>

      {showModal && selected && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleBayar}>
                <div className="modal-header">
                  <h5 className="modal-title">Bayar Angsuran</h5>
                  <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
                </div>
                <div className="modal-body">
                  <p><strong>No. Transaksi:</strong> {selected.NoTransaksi}</p>
                  <p><strong>Sisa Pembayaran:</strong> {formatCurrency(selected.SisaPembayaran)}</p>
                  <div className="form-group">
                    <label>Tgl Bayar</label>
                    <input type="date" className="form-control" value={form.TglBayar}
                      onChange={e => setForm({...form, TglBayar: e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label>Jumlah Bayar (Rp)</label>
                    <input type="number" className="form-control" value={form.JumlahBayar}
                      onChange={e => setForm({...form, JumlahBayar: e.target.value})} required min="1" />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Batal</button>
                  <button type="submit" className="btn btn-success">Bayar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default PembayaranKredit
